import type { UserDTO } from "./AuthService"
import { postJson, secureFetch, secureGetJson, securePostJson } from "./MyFetch"


export interface Attachment {
    id:number
    name:string
    size:number
    contentType:string
}

export interface Message {
    id:number
    ts:Date
    createdId:number
    createdTs:Date
    threadId:number
    recipients:UserDTO[]
    subject:string
    content:string
    draft:string
    attachments:Attachment[]
}

export interface Thread {
    id:number
    createdId:number
    createdTs:Date
    recipients:UserDTO[]
    subject:string
    ts:Date
    messages:Message[]
    messagesCount:number;
}

export async function getMessageById(id:number):Promise<Message> {
    return secureGetJson(`/api/messages/${id}`);
}

export async function updateMessage(message:Message):Promise<Message> {
    return securePostJson(`/api/messages`, message);
}

export async function updateThreadSubject(threadId:number, subject:string):Promise<void> {
    return securePostJson(`/api/messages/subject`, {threadId, subject});
}

export async function findRecipients(emails:string[]):Promise<UserDTO[]> {
    return securePostJson(`/api/users/find-recipients`, emails);
}

export async function getThreads({archived}):Promise<Thread[]> {
    return secureGetJson(`/api/threads?archived=${archived}`);
}

export async function getThread(id:number):Promise<Thread> {
    return secureGetJson(`/api/threads/${id}`);
}

export async function getThreadByMessage(id:number):Promise<Thread> {
    return secureGetJson(`/api/threads/message/${id}`);
}

export async function getThreadUsers(id:number):Promise<UserDTO[]> {
    return secureGetJson(`/api/threads-users/${id}`);
}

export async function archiveThread(threadId:number, archive:boolean):Promise<Thread> {
    return securePostJson(`/api/threads/archive`, {threadId:threadId, archive:archive});
}

export  interface InviteToThreadRequest {
    threadId:number
    users:number[]        
}

export async function inviteToThread(req:InviteToThreadRequest):Promise<Thread> {
    return securePostJson('/api/threads/invite', req);
}

export async function unsubscribeFromThread(req:InviteToThreadRequest):Promise<Thread> {
    return securePostJson('/api/threads/unsubscribe', req);
}

export interface UploadAttachmentResponse {
    id:number
}

export async function uploadAttachment(messageId, file):Promise<UploadAttachmentResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const opts = {
        method: "POST",
        body: formData
    };
    return secureFetch('/api/attachment/add/' + messageId, opts);
}

export async function deleteMessageAttachment(attachmentId):Promise<void> {
    return securePostJson('/api/attachment/delete/' + attachmentId, {});
}
